import { createContext, useContext, useEffect, useState } from "react";
import { strings } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("dd_lang") || "en");

  useEffect(() => {
    localStorage.setItem("dd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = strings[lang];
  const toggle = () => setLang((l) => (l === "en" ? "hi" : "en"));

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
